import { Box } from "@mantine/core";
import React from "react";
import { Flex } from "./RpiFlex";

interface RpiDividerProps {
  label: React.ReactNode;
}

export const RpiDivider: React.FC<RpiDividerProps> = ({ label }) => {
  return (
    <Flex.Row
      gap={16}
      align="center"
      sx={(theme) => ({
        width: "100%",
        fontSize: 16,
        lineHeight: "100%",
        color: theme.colors.text[4],
      })}
    >
      <Box sx={{ flex: 1, height: 1, background: "currentColor" }} />
      <Box sx={{ height: 16, lineHeight: "75%", userSelect: "none" }} children={label} />
      <Box sx={{ flex: 1, height: 1, background: "currentColor" }} />
    </Flex.Row>
  );
};

interface RpiSimpleDividerProps {
  margin?: number;
}

export const RpiSimpleDivider: React.FC<RpiSimpleDividerProps> = ({ margin = 32 }) => {
  return React.useMemo(
    () => (
      <Box
        sx={(theme) => ({
          width: "100%",
          height: 1,
          background: theme.colors.calm[5],
          marginTop: margin,
          marginBottom: margin,
        })}
      />
    ),
    [margin]
  );
};
